// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"3b71201bf245c45e6ffd","71":"37200a91ac450c8f9997","452":"1a64e82dd1006e48205f","885":"3e88a2f932b2e5b66a8c","961":"0d5930b41b573f8ef3e8"}[chunkId] + ".css";
};